<template>
  <div class="home-wrapper">
    <div class="box">
      <div class="exhibition">
        新国际展区
      </div>
      <div class="record" @click="record">代报名记录</div>
      <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane class="pane" label="观众代报名" name="first">
          <el-form
            ref="formA"
            :model="formA"
            :rules="rules"
            inline
            hide-required-asterisk
            label-width="373px"
            label-position="top"
            class="form"
          >
            <el-form-item label="姓名" class="item" prop="name">
              <el-input
                class="ipt"
                v-model="formA.name"
                placeholder="请填写姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号码" class="mobile">
              <el-input class="ipt" v-model="formA.mobile">
                <el-select
                  style="width: 130px"
                  v-model="formA.phonecode"
                  slot="prepend"
                  placeholder="请选择"
                  @change="phoneCodeChange"
                >
                  <el-option
                    v-for="item in clist"
                    :key="item.id"
                    :label="item.name_zh + '(+' + item.phonecode + ')'"
                    :value="item.phonecode"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="证件类型" class="item" prop="country">
              <el-select
                class="ipt"
                v-model="formA.cardType"
                placeholder="请选择证件类型"
              >
                <el-option
                  v-for="item in cardList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" class="item" prop="idcard">
              <el-input
                class="ipt"
                placeholder="请填写证件号码"
                v-model="formA.idcard"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="身份信息" class="item" prop="type">
              <el-select
                class="ipt"
                v-model="formA.type"
                placeholder="请选择身份信息"
                @change="statusChange"
              >
                <el-option label="专业观众" value="2"></el-option>
                <el-option label="消费者" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="国家" class="item" prop="country">
              <el-select
                class="ipt"
                v-model="formA.country"
                placeholder="请选择活动区域"
                @change="countryChange"
              >
                <el-option
                  v-for="item in clist"
                  :key="item.id"
                  :label="item.name_zh"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="省市区"
              class="item"
              prop="city"
              v-if="formA.country == 44"
            >
              <el-cascader
                class="ipt"
                v-model="formA.area"
                :options="cityList"
                placeholder="请选择省市区"
                :props="{ value: 'id', label: 'name', children: 'child' }"
                @change="cityChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="公司" class="item" prop="company_name">
              <el-input
                class="ipt"
                placeholder="请填写公司"
                v-model="formA.company_name"
              ></el-input>
            </el-form-item>
            <el-form-item label="部门" class="item" prop="department">
              <el-input
                class="ipt"
                placeholder="请填写部门"
                v-model="formA.department"
              ></el-input>
            </el-form-item>
            <el-form-item label="职务" class="item" prop="job">
              <el-input
                class="ipt"
                placeholder="请填写职务"
                v-model="formA.job"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="btm">
            <el-button
              class="btn"
              round
              type="primary"
              @click="save('formA')"
              :loading="submitLoading"
              >{{ is_reservation == 1 ? '提交报名，预约入场时间' : '提交报名' }}</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane class="pane" label="观众批量代报名" name="second">
          <div class="step">
            <div class="s1">
              <span class="serial-num">1</span>
              <span class="i1" @click="uploadExcelExampleFile"
                >下载EXCEL示例文件</span
              >
              <span class="i2">请根据示例文件格式填写观众信息</span>
            </div>
            <div class="s2">
              <span class="serial-num">2</span>
              <span class="i1">上传文件进行报名</span>
            </div>
          </div>
          <div class="upload">
            <el-upload
              :disabled="
                uploadProgress.status == 'success' ||
                uploadProgress.status == 'error'
              "
              accept=".xls, .xlsx"
              ref="upload"
              :http-request="uploadSectionFile"
              :before-upload="beforeAvatarUpload"
              :on-success="successUpload"
              :on-error="errorUpload"
              :on-progress="progressUpload"
              :auto-upload="false"
              :drag="true"
              :limit="1"
              :file-list="fileList"
              :multiple="false"
              action="string"
            >
              <!-- 上传提示 -->
              <div v-show="uploadProgress.status == ''">
                <img src="../../assets/upload.png" alt class="icon" />
                <div
                  class="el-upload__text"
                  style="color: #a3a3a3; font-size: 16px; margin-top: 20px"
                >
                  点击或将文件（xls,xlsx）拖拽到这里上传
                </div>
                <div style="margin-top: 10px">
                  <el-button type="primary" size="small" class="button"
                    >&nbsp;&nbsp;选取文件&nbsp;&nbsp;</el-button
                  >
                </div>
              </div>
              <!-- 上传中 -->
              <div
                v-show="uploadProgress.status == 'loading'"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="uploadProgress.value"
                  status="exception"
                  style="width: 70%; margin-top: 90px"
                ></el-progress>
              </div>
              <!-- 上传成功 -->
              <div v-show="uploadProgress.status == 'success'">
                <img src="../../assets/uploadSuccess.png" alt class="icon" />
                <p>上传成功</p>
                <!-- <router-link
                :to="{name:'exhibitorList',query:{state:'success',user_role_no:$route.query.user_role_no , source:'upload'}}"
                tag="span"
              >
                <el-button type="primary" size="small" class="button">查看观众列表</el-button>
              </router-link> -->
              </div>
              <!-- 上传失败 -->
              <div v-show="uploadProgress.status == 'error'">
                <img src="../../assets/uploadError.png" alt class="icon" />
                <p>{{ uploadErrorText }}</p>
                <el-button
                  type="primary"
                  size="small"
                  class="button"
                  @click="againUpload"
                  >重新上传</el-button
                >
              </div>
            </el-upload>
          </div>
          <div class="tips">
            <span class="tip-box">
              <!-- style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#FFD4D4;" 
            class="tip-txt"-->
              <span class="point"></span>
              <span class="tip-txt">下载EXCEL示例文件并填写观众信息</span>
            </span>
            <span class="tip-box">
              <span class="point"></span>
              <span class="tip-txt"
                >上传文件不超过2M，仅支持Excel（xls、xlsx）文件</span
              >
            </span>
            <span class="tip-box">
              <span class="point"></span>
              <span class="tip-txt">支持分批次上传</span>
            </span>
            <!-- <br/> -->
            <span class="tip-box" style="display: block">
              <span class="point"></span>
              <span class="tip-txt"
                >导入时，若该手机号已被代报名，则覆盖上次代报名信息。</span
              >
            </span>
          </div>
          <div class="btm">
            <el-button
              class="btn"
              round
              type="primary"
              @click="submitUpload"
              :loading="submitLoading"
              >提交报名</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="代报名记录"
      :visible.sync="dialogTableVisible"
      width="70%"
    >
      <el-table
        :data="tableData"
        :header-cell-style="{ backgroundColor: 'rgba(16,68,147, 0.24)', color: '#000' }"
      >
        <el-table-column type="index" label="ID" width="50"></el-table-column>
        <el-table-column
          property="source_type_value"
          label="方式"
          width="150"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
          width="100"
        ></el-table-column>
        <el-table-column property="mobile" label="手机号"></el-table-column>
        <el-table-column property="IDcard" label="证件号码"></el-table-column>
        <!-- <el-table-column label="预约时间">
          <template slot-scope="scope">
            <span class="download" @click="view(scope.row.reservation)"
              >查看</span
            >
          </template>
        </el-table-column> -->
        <el-table-column
          property="created_at"
          label="提交时间"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              class="download"
              v-if="scope.row.excel_url"
              @click="downloadExcel(scope.row.excel_url)"
              >下载Excel</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pages">
        <el-pagination
          background
          layout=" prev, pager, next,sizes, total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="sizes"
          :current-page="currentPage"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="预约时间" :visible.sync="timeDialog" width="20%">
      <div v-if="timeList.length > 0">
        <div v-for="(item, index) in timeList" :key="index">
          {{ item.date }}  {{ item.time == 1 ? '上午' : '下午' }}
        </div>
      </div>
      <div v-else>
        暂无预约时间
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="close"
      :close-on-press-escape="close"
      :show-close="close"
      :visible.sync="pop"
      width="628px"
    >
      <div class="title">
        请选择您的入场时间
        <!-- <span class="stitle">（*蓝色加粗数字为可预约余量）</span> -->
      </div>
      <div class="timeList">
        <div v-for="(item, index) in keyList" :key="index" class="item">
          <div class="time">
            {{ item.split("-")[1] + "月" + item.split("-")[2] + "日" }}
          </div>
          <div class="checkBox">
            <div
              v-for="(itm, idx) in dateList[item]"
              :key="idx"
              class="checkItem"
              :class="ids.find((e) => e == itm.id) ? 'checked' : ''"
              @click="clickId(item, idx)"
            >
              <div class="item-top">
                <!-- <div class="code">
                  {{ itm.code }}
                </div> -->
                <div class="sd">
                  {{ itm.time == 1 ? "上午" : "下午" }}
                </div>
              </div>
              <!-- <div class="item-mid">
                {{ itm.time == 1 ? "8:00-12:00" : "13:00-17:00" }}
              </div>
              <div class="item-btm">
                {{ itm.left_count }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="submit">确认</div>
        <!-- <div class="cancel" @click="cancel">暂不选择</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  city,
  customerApplySelectOption,
  reApplyList,
  countryList,
  downloadExample,
  importApply,
  customerReplaceApply,
  getEnterTime,
  checkEnterTime
} from "../../api/data";
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写您的手机号码"));
      } else {
        if (
          !/(^1\d{10}$)/.test(this.formA.mobile) &&
          this.formA.phonecode == 86
        ) {
          callback(new Error("手机号码格式错误"));
        }
        callback();
      }
    };

    var validateCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写您的身份证号码"));
      } else {
        if (
          !/(^[0-9a-zA-Z]{18}$)/.test(this.formA.idcard) &&
          this.formA.cardType == 1
        ) {
          callback(new Error("身份证号码格式错误"));
        }
        callback();
      }
    };
    return {
      info: {},
      apply_type: 1,
      activeName: "first",
      cardList: [],
      clist: [],
      cityList: [],
      gridData: [],
      fileList: [],
      submitLoading: false,
      dialogTableVisible: false,
      formA: {
        name: "",
        mobile: "",
        cardType: 1,
        idcard: "",
        email: "",
        phonecode: 86,
        country: 44,
        area: [0, 0, 0],
        code: "",
        address: "",
        type: "",
        channel: [],
        product: [],
        level: "",
        company_name: "中国",
        job: "",
        department: "",
        sex: "1",
        age: "",
        other: "",
        sumbitType: 1,
        company_name: "",
        department: "",
        job: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写您的姓名", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: "blur" },
        ],
        idcard: [{ required: true, validator: validateCard, trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          // {
          //   type: "email",
          //   message: "请输入正确的邮箱地址",
          //   trigger: ["blur", "change"],
          // },
        ],
        company_name: [
          { required: true, message: "请填写您的公司", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请填写您的部门", trigger: "blur" },
        ],
        job: [{ required: true, message: "请填写您的职位", trigger: "blur" }],
      },
      uploadProgress: {
        timer: null,
        value: 0,
        status: "",
      },
      uploadErrorText: "",
      tableData: [],
      total: 0,
      page: 1,
      sizes: [10, 20, 50],
      currentPage: 0,
      newDate: [],
      pageSize: 10,
      country_name: "中国",
      timeDialog: false,
      timeList: [],
      close: false,
      pop: false,
      dateList: [],
      keyList: [],
      ids: [],
      is_reservation: 1
    };
  },
  mounted() {
    this.getList();
    this.getCity();
    this.countryList();
    this.getTime()
    this.is_reservation = this.$route.query.is_reservation
    // this.getTag()
    // this.getInfo()
  },
  methods: {
    getTime() {
      getEnterTime().then((res) => {
        if (res.code == 0) {
          this.dateList = res.data.reduce(
            (r, x) => ((r[x.date] || (r[x.date] = [])).push(x), r),
            {}
          );
          var key = [];
          res.data.map((item) => {
            key.push(item.date);
          });
          for (var i = 0; i < key.length; i++) {
            if (this.keyList.indexOf(key[i]) === -1) {
              this.keyList.push(key[i]);
            }
          }
        }
      });
    },
    clickId(item, idx) {
      this.ids.indexOf(this.dateList[item][idx].id)
      if (this.ids.indexOf(this.dateList[item][idx].id) > -1) {
        this.ids.splice(this.ids.indexOf(this.dateList[item][idx].id), 1)
      } else {
        this.ids.push(this.dateList[item][idx].id)
      }
    },
    submit() {
      const data = { ids: this.ids, is_en: 0 }
      if (this.mobile != '') {
        data.mobile = this.formA.mobile
      }
      checkEnterTime(data).then(res => {
        if (res.code === 0) {
          this.pop = false
          // this.getUserTime()
          this.$router.push({ name: "agent-done", query: { mobile: this.formA.mobile }});
        }
      })
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getRecord();
    },
    //改变条数
    handleSizeChange(value) {
      // this.$refs.multipleTable.clearSelection();
      // this.currentSelection = [];
      this.page = 1; //重置页码为1
      this.pageSize = value;
      this.getRecord();
    },
    record() {
      this.dialogTableVisible = true;
      this.getRecord();
    },
    startUpload(file) {
      console.log(file);
    },
    // 验证
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      let fileType = ["xls", "xlsx"].includes(testmsg);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!fileType) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "warning",
        });
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
      }
      return fileType && isLt2M;
    },
    //开始上传
    uploadSectionFile(File) {
      let form = new FormData();
      form.append("file", File.file);
      form.append("operate_mobile", this.$route.query.mobile);
      form.append("source_type", 2);
      this.progressUpload(); //加载进度条
      importApply(form)
        .then((reg) => {
          this.uploadErrorText = "";
          let { data } = reg;
          console.log(reg);
          if (reg.code == 0) {
            this.successUpload();
          } else {
            this.errorUpload(reg.msg);
          }
        })
        .catch((err) => {
          this.uploadErrorText = "";
          this.errorUpload(err.msg);
        });
    },
    //正在上传中
    progressUpload(event, file, fileList) {
      this.uploadProgress.status = "loading";
      this.uploadProgress.timer = setInterval(() => {
        this.uploadProgress.value++;
        if (this.uploadProgress.value == 99) {
          clearInterval(this.uploadProgress.timer);
        }
      });
    },
    //上传成功
    successUpload(response, file, fileList) {
      this.$refs.upload.clearFiles();
      this.uploadProgress.status = "success"; //将状态置为成功
      this.uploadProgress.value = 100; //将进度设置为100
      clearInterval(this.uploadProgress.timer); //清楚定时器
    },
    //上传失败
    errorUpload(err, file, fileList) {
      console.log(err);
      this.uploadErrorText = err;
      this.uploadProgress.status = "error"; //将状态置为失败
      this.$refs.upload.clearFiles();
      this.uploadProgress.value = 0; //将进度重置为0
      clearInterval(this.uploadProgress.timer); //清楚定时器
    },
    //重新上传
    againUpload() {
      this.$refs.upload.clearFiles();
      this.uploadProgress = {
        timer: null,
        value: 0,
        status: "",
      };
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    downloadExcel(url) {
      let downloadElement = document.createElement("a"); // 新建一个DOM节点
      downloadElement.href = url;
      document.body.appendChild(downloadElement); // 将新增的节点挂载到页面上
      downloadElement.click();
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
    //下载EXCEL示例文件
    uploadExcelExampleFile() {
      downloadExample().then((res) => {
        console.log(res);
        // this.uploadErrorText = "";
        // let { data } = reg;
        if (res.code == 0) {
          let url = res.data.url;
          let downloadElement = document.createElement("a"); // 新建一个DOM节点
          downloadElement.href = url;
          document.body.appendChild(downloadElement); // 将新增的节点挂载到页面上
          downloadElement.click();
          document.body.removeChild(downloadElement); // 下载完成移除元素
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    statusChange(v) {
      console.log(v);
      this.formA.type = v;
    },
    phoneCodeChange(v) {
      this.formA.phonecode = v;
      console.log(this.formA.phonecode);
      // this.form.type = v
    },
    countryChange(v) {
      this.formA.country = v;
      console.log(v);
      for (let item of this.clist) {
        if (item.id == this.formA.country) {
          this.country_name = item.name_zh;
        }
      }
    },
    cityChange(v) {
      // this.form.country = v
      this.formA.area = v;
      console.log(v);
      for (let item of this.cityList) {
        if (item.id == this.formA.area[0]) {
          this.province_name = item.name;
          for (let item1 of item.child) {
            if (item1.id == this.formA.area[1]) {
              this.city_name = item1.name;
              for (let item2 of item1.child) {
                // console.log(item2)
                if (item2.id == this.formA.area[2]) {
                  console.log(item2.id);
                  this.district_name = item2.name;
                }
              }
            }
          }
        }
      }
    },
    getList() {
      customerApplySelectOption().then((res) => {
        this.cardList = res.data.IDcardType;
      });
    },
    getRecord() {
      reApplyList({
        operate_mobile: this.$route.query.mobile,
        page: this.page,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.tableData = res.data.list;

          this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    getCity() {
      // 删除空的child
      let recursion = (datas) => {
        datas.forEach((item) => {
          if (item.child.length == 0) {
            delete item.child;
          } else {
            recursion(item.child);
          }
          item.sel = false;
          if (item.child) {
            // item.children = item.child;
            item.sel = false;
          }
        });
      };
      city().then((res) => {
        recursion(res.data);
        this.cityList = res.data;
      });
    },
    countryList() {
      countryList().then((res) => {
        this.clist = res.data;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    save(formA) {
      this.$refs[formA].validate((valid) => {
        if (valid) {
          if (this.formA.area[0] == 0 && this.formA.country == 44) {
            this.$message.error("请选择您的地区");
          } else {
            let channel_id = 0;
            if (this.$route.query.channel_id) {
              channel_id = this.$route.query.channel_id;
            }
            let data = {
              source_type: 1,
              operate_mobile: this.$route.query.mobile,
              name: this.formA.name,
              phonecode: this.formA.phonecode,
              mobile: this.formA.mobile,
              IDcard_type: this.formA.cardType,
              IDcard: this.formA.idcard,
              email: this.formA.email,
              country_id: this.formA.country,
              country_name: this.country_name,
              province_id: this.formA.area[0],
              province_name: this.province_name,
              city_id: this.formA.area[1],
              city_name: this.city_name,
              district_id: this.formA.area[2],
              district_name: this.district_name,
              //消费者
              // type: this.formA.type,
              type: 2,
              submitType: this.formA.sumbitType,
              company_name: this.formA.company_name,
              department: this.formA.department,
              job: this.formA.job,
              // area:this.ipt0,
              // standard_booth_num:this.ipt1,
              // hardcover_booth_num:this.ipt2,
            };
            console.log(data);
            this.submitLoading = true;
            customerReplaceApply(data).then((res) => {
              this.submitLoading = false;
              if (res.code == 0) {
                if (res.data.is_reservation == 0) {
                  this.$router.push({ name: "agent-done", query: { mobile: this.formA.mobile }});
                } else {
                  this.pop = true
                }
              } else if (res.code == 100) {
                this.$confirm(res.msg)
                  .then((_) => {
                    this.formA.sumbitType = 2;
                    this.save(formA);
                    done();
                  })
                  .catch((_) => {});
              } else if (res.code == 410) {
                this.$alert('身份证核验异常，请确认姓名、身份证是否填写错误，如正确但仍然异常，您可稍后再试或本人持身份证原件至展会观众登记处进行现场注册”', '', {
                  showClose: false,
                  showCancelButton: false

                })
                .then(_ => {
                  done();
                })
                .catch(_ => {});
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    view(list) {
      this.timeDialog = true
      this.timeList = list
    }
  },
};
</script>



<style scoped>
.home-wrapper {
  width: 100%;
  height: 100%;
  background: url("https://aweqn.zhiandexpo.com/awe2027pc.jpg") no-repeat;
  background-size: contain;
  padding-top: 400px;
  padding-bottom: 200px;
}
.box {
  width: 1200px;
  /* height: 820px; */
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.24);
  border-radius: 27px;
  margin: 0 auto;
  padding: 50px 40px;
  box-sizing: border-box;
  position: relative;
}
.exhibition {
  font-size: 16px;
  font-weight: bold;
  font-family: SourceHanSansSC, SourceHanSansSC;
  padding: 2px 8px;
  border-radius: 7px;
  background: #1C519A;
  color: #fff;
  display: inline-block;
  margin-bottom: 20px;
}
.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: -10px;
}
.ipt {
  width: 290px;
}
.tabs {
  width: 100%;
}
.pane {
  color: #303053;
}
.record {
  position: absolute;
  top: 97px;
  right: 40px;
  text-decoration: underline;
  color: #1C519A;
  cursor: pointer;
  font-size: 20px;
  z-index: 66;
}
.step {
  margin-bottom: 30px;
}
.serial-num {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #1C519A;
  background: #fff;
  color: #1C519A;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
}
.s1 {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.s1 .i1 {
  cursor: pointer;
  color: #1C519A;
  margin-left: 10px;
}
.s1 .i2 {
  color: #a3a3a3;
  margin-left: 20px;
}
.s2 {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.s2 .i1 {
  color: #000;
  margin-left: 10px;
}
.home-wrapper >>> .el-tabs__item {
  font-size: 20px;
}
.home-wrapper >>> .el-tabs__item:hover {
  color: #303053;
}
.home-wrapper >>> .el-tabs__item.is-active {
  color: #303053;
  font-size: 24px;
}
.home-wrapper >>> .el-tabs__active-bar {
  background-color: #303053;
}
.home-wrapper /deep/ .el-upload {
  width: 100% !important;
}
.home-wrapper /deep/ .el-upload-dragger {
  width: 100% !important;
  border: 1px dashed #303053 !important;
  height: 200px !important;
}
.btm {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
.upload .button {
  background-color: #303053;
  border-color: #303053;
}
.btn {
  width: 300px;
}
.tips {
  padding-top: 14px;
}
.tip-box {
  padding-top: 14px;
  padding-right: 35px;
}
.point {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 184, 224, 0.4);
}
.tip-txt {
  font-size: 14px;
  color: #a3a3a3;
}
.icon {
  margin-top: 40px;
  width: 36px;
  height: 36px;
}
.pages {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}
.download {
  color: #1C519A;
  cursor: pointer;
}
.title {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
.stitle {
  font-size: 12px;
  color: #1C519A;
  font-weight: 400;
}
.timeList {
  display: flex;
  flex-wrap: wrap;
}
.timeList .item {
  width: 118px;
  /* margin-bottom: 20px;
  margin-right: 24px; */
  margin: 20px 24px 20px 0;
}
.time {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
}
.checkBox {
  width: 118px;
  height: 204px;
}
.checkItem {
  width: 118px;
  height: 82px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.checked {
  border: 1px solid #1C519A;
  color: #333333;
}
.item-top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-btm {
  color: #1C519A;
}
.code {
  font-weight: 500;
  margin-right: 4px;
}
.el-dialog__body .btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}
.submit {
  cursor: pointer;
  width: 190px;
  height: 32px;
  background: #1C519A;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
}
.btm /deep/ .el-button--primary:hover {
  background: #1C519A;
}
.btm /deep/ .el-button--primary {
  background: #1C519A;
  border-color: #1C519A;
}
</style>


// WEBPACK FOOTER //
// src/views/home/agent.vue